module.exports = __webpack_public_path__ + "img/3화_5(1).69fc16a0.jpg";